export const DEFAULT_D2L_REMINDER_INTERVAL = 20;
export const D2L_REMINDER_INTERVALS = [5, 10, 15, 20, 30, 45, 60];

export function d2lReminderSettings(value) {
  return {
    enabled: value?.enabled === true,
    intervalMinutes: Number.isInteger(value?.intervalMinutes) && value.intervalMinutes >= 5 && value.intervalMinutes <= 60
      ? value.intervalMinutes : DEFAULT_D2L_REMINDER_INTERVAL,
  };
}

// Omit untouched fields: editing dates/access must not opt a legacy lab in or
// replace another instructor's reminder choice while the settings form is open.
export function d2lReminderPatch(value, baseline) {
  const next = d2lReminderSettings(value), before = d2lReminderSettings(baseline);
  const patch = {};
  if (next.enabled !== before.enabled) patch.enabled = next.enabled;
  if (next.intervalMinutes !== before.intervalMinutes) patch.intervalMinutes = next.intervalMinutes;
  return Object.keys(patch).length ? patch : undefined;
}
